/**
 * Thông báo "có bản mới" — Prompt.md §32, Bước 17.
 *
 * Vì sao không tự reload: một phiên học đang chạy có camera stream, baseline đã calibrate và
 * session chưa ghi bản final. Reload ngầm sẽ mất cả ba. Người dùng chọn thời điểm.
 */

import { pwaMessages } from "@studystraight/shared-config";
import { useSyncExternalStore } from "react";

import {
  dismissUpdate,
  getUpdateState,
  reloadWithUpdate,
  subscribeUpdates,
} from "./registerSW.js";

export function UpdatePrompt(): React.JSX.Element | null {
  const { updateReady } = useSyncExternalStore(subscribeUpdates, getUpdateState, getUpdateState);

  if (!updateReady) return null;

  return (
    <div className="update-prompt" role="status">
      <p className="update-prompt__text">{pwaMessages.updateReady}</p>
      <div className="update-prompt__actions">
        <button type="button" className="btn btn--small" onClick={reloadWithUpdate}>
          {pwaMessages.reload}
        </button>
        <button type="button" className="btn btn--small btn--secondary" onClick={dismissUpdate}>
          {pwaMessages.later}
        </button>
      </div>
    </div>
  );
}
